<template>
  <div>
    <Navbar />
    <div class="main-banner-area">
      <div class="container-fluid">
        <div class="container">
          <div class="col-md-12">
            <div class="about-content">
              <h4 class="text-center">{{ title }}</h4>
              <p>The role of this department is to:</p>
              <ul class="text-justify">
                <li>{{ role1 }}</li>
                <li>{{ role2 }}</li>
                <li v-if="role3 !== undefined">{{ role3 }}</li>
                <li v-if="role4 !== undefined">{{ role4 }}</li>
                <li v-if="role5 !== undefined">{{ role5 }}</li>
                <li v-if="role6 !== undefined">{{ role6 }}</li>
                <li v-if="role7 !== undefined">{{ role7 }}</li>
                <li v-if="role8 !== undefined">{{ role8 }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Footer from "../../Footer";

export default {
  components: {
    Navbar,
    Footer
  },
  props: [
    "title",
    "role1",
    "role2",
    "role3",
    "role4",
    "role5",
    "role6",
    "role7",
    "role8"
  ],
  watch: {
    '$route.params.title': function() {
      console.log(this.title)
    }
  }
};
</script>

<style scoped></style>
